import { combineReducers } from '@/utils/combineReducers';
import {
  ActionType,
  CONFIG_CHANGED,
  DATA_CHANGED,
  DESCRIPTION_CHANGED,
  EDITOR_MODE_CHANGED,
  QR_CODE_CTA_CHANGED,
  SERVER_ENGAGEMENT_RECEIVED,
  TITLE_CHANGED,
} from './actions';
import { FullEngagementFragment } from '@/generated/graphql';

export type AdminEngagementState = FullEngagementFragment & {
  editorMode: 'stage' | 'mobile';
};

const fieldReducer = combineReducers<AdminEngagementState, ActionType>({
  id: (state) => state,
  eventId: (state) => state,
  createdAt: (state) => state,
  updatedAt: (state) => state,
  title: titleReducer,
  description: descriptionReducer,
  qrCodeCta: qrCodeCtaReducer,
  startTime: (state) => state,
  endTime: (state) => state,
  type: (state) => state,
  order: (state) => state,
  config: configReducer,
  data: dataReducer,
  viewConfig: (state) => state,
  viewData: (state) => state,
  editorMode: editorModeReducer,
});

function titleReducer(
  state: AdminEngagementState['title'],
  action: ActionType,
) {
  switch (action.type) {
    case TITLE_CHANGED: {
      return action.payload.title;
    }
    default: {
      return state;
    }
  }
}

function descriptionReducer(
  state: AdminEngagementState['description'],
  action: ActionType,
) {
  switch (action.type) {
    case DESCRIPTION_CHANGED: {
      return action.payload.description;
    }
    default: {
      return state;
    }
  }
}

function configReducer(
  state: AdminEngagementState['config'],
  action: ActionType,
) {
  switch (action.type) {
    case CONFIG_CHANGED: {
      return {
        ...state,
        ...action.payload.config,
      } as AdminEngagementState['config'];
    }
    default: {
      return state;
    }
  }
}

function dataReducer(state: AdminEngagementState['data'], action: ActionType) {
  switch (action.type) {
    case DATA_CHANGED: {
      return {
        ...state,
        ...action.payload.data,
      };
    }
    default: {
      return state;
    }
  }
}

function qrCodeCtaReducer(
  state: AdminEngagementState['qrCodeCta'],
  action: ActionType,
) {
  switch (action.type) {
    case QR_CODE_CTA_CHANGED: {
      return action.payload.qrCodeCta;
    }
    default: {
      return state;
    }
  }
}

function editorModeReducer(
  state: AdminEngagementState['editorMode'],
  action: ActionType,
) {
  switch (action.type) {
    case EDITOR_MODE_CHANGED: {
      return action.payload.editorMode;
    }
    default: {
      return state;
    }
  }
}

export function reducer(
  state: AdminEngagementState,
  action: ActionType,
): AdminEngagementState {
  if (action.type === SERVER_ENGAGEMENT_RECEIVED) {
    return action.payload;
  }
  return fieldReducer(state, action);
}
